import './style-boleto.css'

import PropTypes from 'prop-types'
import React from 'react'

import moment from '../../helpers/moment'
import Currency from '../_common/Currency'


const _ = require('lodash');

const createIvcBean = (invoices) => {


    let ivcs = [];

    const recurrencyInvoices = invoices.filter(invoice => {
        if (!invoice.invoiceAccount || !invoice.invoiceAccount.accounts) {
            return false
        }

        return invoice.invoiceAccount.accounts.some(a => !!a.recurrent)
    })
    const recurrencyIVAs = _.uniqBy(
        recurrencyInvoices.map(i => ({date: i.documentDate, invoiceAccount: i.invoiceAccount })),
        (iva) => `${iva.date}-${iva.invoiceAccount.code}`)
    const nonRecurrencyInvoices = invoices.filter(invoice => !recurrencyInvoices.includes(invoice))

    ivcs = _.concat(ivcs, recurrencyIVAs.map(iva => {
        const productNames = iva.invoiceAccount.accounts.map(acc => acc.productRelease.name).reduce((str, name) => str += '|' + name);
        const value = recurrencyInvoices.filter(ivc => ivc.invoiceAccount.code == iva.invoiceAccount.code &&
                moment(new Date(ivc.documentDate)).format('MMM/YYYY') === moment(new Date(iva.date)).format('MMM/YYYY'))
                .map(ivc => ivc.value).reduce((total, value) => parseFloat(total) + parseFloat(value))

        return {
            description: `#${iva.invoiceAccount.code} - ${productNames}`,
            value,
            monthReference: moment(new Date(iva.date)).format('MMM/YYYY')
        }
    }))

    ivcs = _.concat(ivcs, nonRecurrencyInvoices.map(ivc => {

        return {
            description: ivc.description,
            value: ivc.value,
            monthReference: moment(new Date(ivc.documentDate)).format('MMM/YYYY'),
            installment: ivc.installment
        }
    }))



    return _.uniqBy(ivcs , i => i.description )
}

export const InvoiceTable = (props) => {

    const {invoices, totalValue} = props;
    const ivcs = createIvcBean(invoices);

    return(
        <div className='ivcTable'>
            <table>
                <thead>
                <tr>
                    <th style={{width:'65%'}}> </th>
                    <th > </th>
                    <th style={{width: 95 }}>Mês Ref. </th>
                    <th style={{width: 160 }}>Valor</th>
                </tr>
                </thead>
                <tbody>
                    {ivcs.map((ivc)=>
                        <tr key={ivc.monthReference + '-' + ivc.description}>
                            <td style={{textAlign:'left'}}>{ivc.description}</td>
                            <td>{ivc.installment}</td>
                            <td> {ivc.monthReference} </td>
                            <td style={{textAlign: 'right'}}>
                                <Currency value={parseFloat(ivc.value)}/>
                            </td>
                        </tr>
                    )}
                </tbody>
                <tfoot>
                    <tr>
                        <th style={{ fontSize: '0.85rem', textAlign: 'left' }}>
                            Total
                        </th>
                        <th colSpan='3' style={{textAlign: 'right'}} >
                            <b style={{fontSize: 18}}><Currency value={totalValue}/></b>
                        </th>
                    </tr>
                </tfoot>
            </table>

            <ul>
                {ivcs.map((ivc)=>
                    <li key={ivc.monthReference + '-' + ivc.description}>
                        <b>{ivc.description}</b> - <Currency value={parseFloat(ivc.value)}/> <br/>
                        {ivc.monthReference} <br/>
                        {ivc.installment} <br/><br/>
                    </li>
                )}
            </ul>
        </div>
    )
}

InvoiceTable.PropTypes = {
    invoices: PropTypes.object.isRequired,
    totalValue: PropTypes.number.isRequired
}

export default InvoiceTable



// WEBPACK FOOTER //
// ./src/components/BankBillet/InvoiceTable.js